import React, { FunctionComponent, ReactElement } from 'react';
import classnames from 'classnames';
import ArrowDown from 'dibs-icons/exports/ArrowDown';
import { Link } from 'dibs-elements/exports/Link';

import style from './ReadMoreButton.scss';

type ReadMoreButtonProps = {
    isExpanded?: boolean;
    className?: string;
    showArrow?: boolean;
    onClick: () => void;
    readLessMessage: ReactElement;
    readMoreMessage: ReactElement;
};

export const ReadMoreButton: FunctionComponent<ReadMoreButtonProps> = ({
    isExpanded,
    className,
    onClick,
    readLessMessage,
    readMoreMessage,
    showArrow = true,
}) => {
    const arrowClassName = classnames(style.arrow, {
        [style.expanded]: isExpanded,
    });
    const dataTn = isExpanded ? 'read-less' : 'read-more';

    return (
        <Link
            className={classnames(style.button, className)}
            underline="none"
            onClick={onClick}
            dataTn={dataTn}
        >
            {isExpanded ? readLessMessage : readMoreMessage}
            {showArrow && <ArrowDown className={arrowClassName} />}
        </Link>
    );
};
